import { sourceGroupMap } from "./consts";

// Group sources dynamically
export const getGroupingOfSources = (sources) => {
    const groupedSources = sources.reduce((acc, source) => {
        const groupData = sourceGroupMap[source.toLowerCase()]; // Map source to group
        if (groupData) {
            const { group, type } = groupData;
            if (!acc[group]) {
                acc[group] = [];
            }
            acc[group].push({ source, type });
        }
        return acc;
    }, {});

    // Convert groupedSources to an array for rendering
    return Object.entries(groupedSources).map(
        ([group, sources]) => ({
            group,
            sources,
        })
    );
};